export const environment = {
  production: true,
  debug: false,
  url: "https://www.soteria-spbfamily.eu:8084/v2"
};
